export default {
	navTheme: "dark",
	primaryColor: "#1890ff",
	layout: "side",
	contentWidth: "Fluid",
	fixedHeader: false,
	fixSiderbar: true,
	colorWeak: false,
	headerRender: false,
	breadcrumbRender: false,
	menu: {
		locale: true,
	},
	title: "uPOS Portal",
	pwa: false,
	iconfontUrl: "",
};